<template>
  <div class="page-shell">
    <AppCard class="terms-card" unstyled>
      <h2 class="section-title">Terms &amp; Conditions</h2>
      <p class="section-text">
        By using our services, you agree to follow the rules outlined in these
        Terms and Conditions. You must provide accurate information and keep
        your account credentials secure.
      </p>
      <p class="section-text">
        Payments are due at the time of booking unless otherwise stated. We may
        cancel or reschedule services due to availability, safety concerns, or
        unforeseen circumstances.
      </p>
      <p class="section-text">
        We are not responsible for delays caused by third parties or events
        outside of our control. Service quality concerns should be reported
        within 48 hours of completion.
      </p>

      <h2 class="section-title">Privacy Policy</h2>
      <p class="section-text">
        We collect your name, contact details, and service preferences to
        provide and improve our services. We do not sell your personal data.
      </p>
      <p class="section-text">
        Your information may be shared with service professionals to complete
        your booking. We use industry-standard security measures to protect your
        data.
      </p>
      <p class="section-text">
        You can request access, updates, or deletion of your data by contacting
        support. Response times may vary based on request volume.
      </p>
    </AppCard>
  </div>
</template>

<script setup lang="ts">
import AppCard from "@/shared/components/ui/AppCard.vue";
</script>

<style scoped>
.page-shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
}

.terms-card {
  background: #fff;
  padding: 14px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-title {
  margin: 0;
  font-size: var(--font-size-default);
  font-weight: 700;
  color: #0f172a;
}

.section-text {
  margin: 0;
  font-size: var(--font-size-default);
  color: #64748b;
  line-height: 1.5;
}
</style>

